import type { CourseificCourse, CourseificVideo } from '@st/courseific'

export const oneHourCourseId = 'one-hour-course'

const bunnyVideo = (videoId: string): CourseificVideo => ({ libraryId: '743682', videoId })

export const oneHourCourse: CourseificCourse = {
  id: oneHourCourseId,
  title: 'Mastering StanfordTax - (One-hour course)',
  chapters: [
    {
      id: 'stanfordtax-overview',
      title: 'StanfordTax Overview',
      lessons: [
        {
          id: 'welcome-to-stanfordtax',
          title: 'Welcome to StanfordTax',
          durationMinutes: 1,
          video: bunnyVideo('7a9ba645-7a25-457b-bb67-2b7e8a82305a')
        },
        {
          id: 'getting-started',
          title: 'Getting started',
          durationMinutes: 1,
          video: bunnyVideo('d0108745-dba3-4bc3-b106-070e6dc56896')
        }
      ]
    },
    {
      id: 'generating-binders',
      title: 'Generating Binders',
      lessons: [
        {
          id: 'generating-binders-for-returning-clients',
          title: 'Generating binders for returning clients',
          durationMinutes: 1,
          video: bunnyVideo('faa927b3-602a-4158-89b1-2995562c83fc')
        },
        {
          id: 'generating-binders-for-new-clients',
          title: 'Generating binders for new clients',
          durationMinutes: 1,
          video: bunnyVideo('90e52b12-918a-4f5f-9a64-ed5350448e72')
        },
        {
          id: 'generating-binders-for-prior-tax-years',
          title: 'Generating binders for prior tax years',
          durationMinutes: 1,
          video: bunnyVideo('d00f8aff-e8bf-456b-8853-e277a685bb76')
        }
      ]
    },
    {
      id: 'binder-fundamentals',
      title: 'Binder Fundamentals',
      lessons: [
        {
          id: 'adding-documents-to-the-binder',
          title: 'Adding documents to the binder',
          durationMinutes: 3,
          video: bunnyVideo('719a1aee-2437-47af-848c-ddb40d05a39b')
        },
        {
          id: 'utilizing-the-checklist',
          title: 'Utilizing the checklist',
          durationMinutes: 3,
          video: bunnyVideo('3b2f77bc-b23f-4256-8fb9-d5496ddd6b49')
        },
        {
          id: 'handling-bundled-documents',
          title: 'Handling bundled documents',
          durationMinutes: 4,
          video: bunnyVideo('5459f54b-2ea0-424b-84e6-ca770975f939')
        },
        {
          id: 'annotating-documents',
          title: 'Annotating documents',
          durationMinutes: 2,
          video: bunnyVideo('75fc6107-2015-4fd5-9844-aec2125c6265')
        },
        {
          id: 'signing-off-on-documents',
          title: 'Signing off on documents',
          durationMinutes: 1,
          video: bunnyVideo('39e6d38a-3c08-4cea-9f7e-1efd0bb972cb')
        },
        {
          id: 'exporting-the-binder',
          title: 'Exporting the binder',
          durationMinutes: 2,
          video: bunnyVideo('81258b44-5c41-4060-bc2e-480939e65e6f')
        }
      ]
    },
    {
      id: 'the-client-organizer',
      title: 'The Client Organizer',
      lessons: [
        {
          id: 'what-is-the-client-organizer',
          title: 'What is the client organizer?',
          durationMinutes: 1,
          video: bunnyVideo('28513d81-23a3-4774-ba58-cd188867a00e')
        },
        {
          id: 'the-questionnaire',
          title: 'The questionnaire',
          durationMinutes: 1,
          video: bunnyVideo('e72b0c32-4047-4109-a7e8-a1573bebbe75')
        },
        {
          id: 'the-document-request-list',
          title: 'The document request list',
          durationMinutes: 1,
          video: bunnyVideo('8191bf55-52c7-4dda-9ac4-84f75cbd3720')
        },
        {
          id: 'submitting-the-organizer',
          title: 'Submitting the organizer',
          durationMinutes: 1,
          video: bunnyVideo('ff4e3f36-127a-4c19-bd4d-32eb55fa955d')
        },
        {
          id: 'sending-organizers-to-clients',
          title: 'Sending organizers to clients',
          durationMinutes: 1,
          video: bunnyVideo('b82a3df1-b269-4c39-b276-87b80e061105')
        },
        {
          id: 'managing-client-access',
          title: 'Managing client access',
          durationMinutes: 1,
          video: bunnyVideo('80a59a68-d73b-47a4-99c0-bc1b536a7c9e')
        },
        {
          id: 'automated-reminders',
          title: 'Automated reminders',
          durationMinutes: 1,
          video: bunnyVideo('de08bb4d-8b65-453b-a27a-60140961221a')
        },
        {
          id: 'requesting-missing-documents',
          title: 'Requesting missing documents',
          durationMinutes: 1,
          video: bunnyVideo('e9a38073-be82-4fc4-a514-d5e708abec4d')
        },
        {
          id: 'using-the-organizer-with-new-clients',
          title: 'Using the organizer with new clients',
          durationMinutes: 1,
          video: bunnyVideo('f0cd1550-d9d3-4668-ae74-119b9695fb46')
        },
        {
          id: 'using-the-organizer-with-business-clients',
          title: 'Using the organizer with business clients',
          durationMinutes: 1,
          video: bunnyVideo('62acb2ae-0117-46fe-afa6-310f6f9ccf0d')
        }
      ]
    },
    {
      id: 'miscellaneous-topics',
      title: 'Miscellaneous Topics',
      lessons: [
        {
          id: 'adding-team-members',
          title: 'Adding team members',
          durationMinutes: 1,
          video: bunnyVideo('a79a5e06-a986-4f39-b26d-42dfdf743e74')
        },
        {
          id: 'assigning-binders',
          title: 'Assigning binders',
          durationMinutes: 1,
          video: bunnyVideo('51769aa4-ad31-4b7e-a155-926c828ec11f')
        },
        {
          id: 'using-tags',
          title: 'Using tags',
          durationMinutes: 1,
          video: bunnyVideo('1544aa95-8f23-433a-a1c7-afce675acd10')
        },
        {
          id: 'handling-marital-status-changes',
          title: 'Handling marital status changes',
          durationMinutes: 1,
          video: bunnyVideo('4ab130dd-4fdb-49d2-95f4-7dc476ccd9d5')
        },
        {
          id: 'understanding-stanfordtax-credits',
          title: 'Understanding StanfordTax credits',
          durationMinutes: 1,
          video: bunnyVideo('92cf6700-a406-4b13-b2de-d8c312184ecf')
        }
      ]
    }
  ]
}

export const oneHourCourseLessonIds = oneHourCourse.chapters.flatMap((chapter) =>
  chapter.lessons.map((lesson) => lesson.id)
)
